import * as yup from 'yup';

export const CreateEditArticleSchema = yup.object({
    date: yup.string().required('required'),
    titleFR: yup.string().required('required'),
    titleEN: yup.string().required('required'),
    textFR: yup.string().required('required'),
    textEN: yup.string().required('required'),
    channel: yup.string().required('required'),
});
